export type SliderType = 'mobile' | 'desktop' | 'all';

export const sliderTypeNameMap: Record<SliderType, string> = {
  mobile: 'Mobil',
  desktop: 'Masaüstü',
  all: 'Tümü',
};
